import React from 'react';
import { BRIOTIME_STATUS_COLOR } from '../utils/projectMeta';

function StatusPill({ status }) {
  const color = BRIOTIME_STATUS_COLOR[status] || '#666';
  return (
    <span style={{ padding: '0.1rem 0.45rem', borderRadius: 4, fontSize: '0.72rem', background: color + '20', color }}>
      {status || '—'}
    </span>
  );
}

export default StatusPill;
